
import { Component, Vue } from "vue-property-decorator";

@Component
export default class LogoHome extends Vue {
  public home = document.getElementById("home");
  public showHome = false;

  get homeDisplay() {
    return this.showHome ? "block" : "none";
  }

  mounted() {
    this.showHome = false;
  }

  goHome() {
    // console.log("LogoHome - goHome");
    this.showHome = false;
    this.$router.push("/intro");
  }

}
